import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { Observable } from "rxjs";
import { UserNotify } from "src/app/support/notify-decorator";
import { environment } from "src/environments/environment";
import { Packaging, PackagingCreate } from "../models/packaging";

@Injectable()
export class PackagingBackend {
  constructor(private http: HttpClient) {}

  load(packagingId: string): Observable<Packaging> {
    return this.http.get<Packaging>(
      `${environment.snoots.api.healthcare}/packagings/${packagingId}`
    );
  }

  list(drugId: string): Observable<Packaging[]> {
    return this.http.get<Packaging[]>(
      `${environment.snoots.api.healthcare}/drugs/${drugId}/packagings`
    );
  }

  @UserNotify({
    successMessage: marker("Riconfezionamento creato"),
    errorMessage: marker("Impossibile creare il Riconfezionamento"),
    progressIndeterminate: true,
    progressMessage: marker("Crezione riconfenzionamento")
  })
  create(drugId: string, payload: PackagingCreate): Observable<Packaging> {
    return this.http.post<Packaging>(
      `${environment.snoots.api.healthcare}/drugs/${drugId}/packagings`,
      payload
    );
  }

  @UserNotify({
    successMessage: marker("Riconfezionamento aggiornato"),
    errorMessage: marker("Impossibile aggiornare il riconfenzionamento")
  })
  update(id: string, request: Partial<Packaging>): Observable<void> {
    return this.http.patch<void>(
      `${environment.snoots.api.healthcare}/packagings/${id}`,
      request
    );
  }

  @UserNotify({
    successMessage: marker("Riconfezionamento eliminato"),
    errorMessage: marker("Impossibile eliminare il riconfenzionamento")
  })
  delete(id: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.snoots.api.healthcare}/packagings/${id}`
    );
  }
}
